import axios from "axios";
import { API_BASE_URL1 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";
 
const getToken = () => {
  return localStorage.getItem("token");
};
 
export const AllTripsTonnage = async (StartDate, endDatae) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageReport?startDate=${StartDate}&endDate=${endDatae}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const AllULBReport = async (StartDate, endDatae) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/ULBTripAndTonnageReport?startDate=${StartDate}&endDate=${endDatae}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const ContainerTripsReport = async (StartDate, endDatae) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/ContainerTTRReport?StartDate=${StartDate}&EndDate=${endDatae}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const HookLoaderTripsReport = async (StartDate, endDatae) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/HookloaderTTRReport?startDate=${StartDate}&endDate=${endDatae}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const ZoneWiseContainerTripsReport = async (StartDate, EndDate, ZoneId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/ContainerTripDetailsTTRReport?ZoneId=${ZoneId}&StartDate=${StartDate}&EndDate=${EndDate}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const ZoneWiseContainerVehicleTripsReport = async (StartDate, EndDate, ZoneId, ContainerName, TransferStationName) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/ContainerVehicleTripDetailsTTRReport?ZoneId=${ZoneId}&StartDate=${StartDate}&EndDate=${EndDate}&ContainerName=${ContainerName}&TransferStationName=${TransferStationName}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const ZoneWiseHookLoaderTripsReport = async (StartDate, EndDate, ZoneId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/HookloaderTripDetailsReport?StartDate=${StartDate}&EndDate=${EndDate}&ZoneId=${ZoneId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const VehicleWiseHookLoaderTripsReport = async (StartDate, EndDate, VehicleNumber, ZoneId, TransferStationName) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/HookloaderVehicleTripDetailsTTRReport?VehicleNumber=${VehicleNumber}&StartDate=${StartDate}&EndDate=${EndDate}&ZoneId=${ZoneId}&TransferStationName=${TransferStationName}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const ZonewiseTripsReport = async (StartDate, EndDate, ZoneId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/ZoneWiseTransferStationTTRReport?StartDate=${StartDate}&endDate=${EndDate}&ZoneId=${ZoneId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const ZonewiseULBReport = async (StartDate, EndDate, ZoneId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/ZoneWiseTransferStationULBReport?StartDate=${StartDate}&endDate=${EndDate}&ZoneId=${ZoneId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    console.log(response ,"response")
    return response;
  } catch (error) {
    throw error;
  }
};
export const GHMCTripsReport = async (StartDate, EndDate,ZoneId, Transporter) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}&ZoneId=${ZoneId}&Transporter=${Transporter}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const GHMCTripsTotalReport = async (StartDate, EndDate, Transporter) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}&Transporter=${Transporter}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const HIRETripsReport = async (StartDate, EndDate,ZoneId, Transporter) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}&ZoneId=${ZoneId}&Transporter=${Transporter}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const HIRETotalTripsReport = async (StartDate, EndDate, Transporter) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}&Transporter=${Transporter}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const HIRETonnageReport = async (StartDate, EndDate,ZoneId, Transporter) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}&ZoneId=${ZoneId}&Transporter=${Transporter}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const HIRETonnageTotalReport = async (StartDate, EndDate, Transporter) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}&Transporter=${Transporter}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const HIMSWTripsReport = async (StartDate, EndDate,ZoneId, Transporter) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}&ZoneId=${ZoneId}&Transporter=${Transporter}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const HIMSWTotalTripsReport = async (StartDate, EndDate, Transporter) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}&Transporter=${Transporter}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const TotalTripsReport = async (StartDate, EndDate,ZoneId,) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}&ZoneId=${ZoneId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const TotalWithTripsReport = async (StartDate, EndDate) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const GHMCTonnageReport = async (StartDate, EndDate,ZoneId,Transporter) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}&ZoneId=${ZoneId}&Transporter=${Transporter}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const GHMCTonnageTotalReport = async (StartDate, EndDate,Transporter) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}&Transporter=${Transporter}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const HIMSWTonnageReport = async (StartDate, EndDate,ZoneId,Transporter) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}&ZoneId=${ZoneId}&Transporter=${Transporter}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const HIMSWTonnageTotalReport = async (StartDate, EndDate,Transporter) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}&Transporter=${Transporter}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const TotalTonnageReport = async (StartDate, EndDate,ZoneId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}&ZoneId=${ZoneId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const TotalTonnageWithReport = async (StartDate, EndDate) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TripAndTonnageReport/TripAndTonnageInnerReport?StartDate=${StartDate}&endDate=${EndDate}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const getWeighBridgeTSSCTPWiseSummary = async (requestData) => {
  try {
    const response = await axiosInstance.post(
        API_BASE_URL1 + `getWeighBridgeTSSCTPWiseSummary`,
      requestData
    );
    return response;
  } catch (error) {
    throw error;
  }
};
 
export const getZoneDetails = async () => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `getZoneDetails`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`
      }
    }
    );
    return response;
  } catch (error) {
    throw error;
  }
};